import { Injectable } from '@angular/core';
import { Params } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { SiteModel } from '../models/site.model';
import { MasterDetailResource } from '../services/master-detail-resource';
import { SiteService } from '../services/site.service';

@Injectable({
  providedIn: 'root'
})
export class SiteMasterService
  implements MasterDetailResource<SiteModel, Params, String>
{
  public items: Observable<any[]>;
  public pageSize = 500;
  public pageCount = 0;
  public itemCount = 0;
  public currentPage = 0;
  public pages = [];
  public sampleData = [];
  private readonly _items: BehaviorSubject<any[]>;
  private _lastQuery: Params | undefined;

  private static compareSites(
    a: SiteModel,
    b: SiteModel,
    attribute: string
  ): number {
    return a.compare(b, attribute);
  }
  constructor(private siteService: SiteService) {
    this._items = new BehaviorSubject<any>([]);
    this.items = this._items
      .asObservable()
      .pipe
      // delay(500) // fake some latency
      ();
  }
  queryCity(): Observable<Set<string>> {
    return this.items.pipe(
      map((items) => new Set(items.map((site) => site.city)))
    );
  }

  querySingle(id: string): Observable<SiteModel> {
    return of(this.sampleData.find((value) => value.siteId === id)).pipe(
      first()
      //delay(500) // fake some latency
    );
  }

  queryAll(params?: Params): Observable<SiteModel[]> {
    this._lastQuery = params;

    let page = 0;
    let sortAttribute = 'siteId';

    if (params) {
      if (params.hasOwnProperty('page')) {
        page = +params['page'];
      }

      if (params.hasOwnProperty('sort')) {
        sortAttribute = params['sort'];
      }
    }

    const start = page * this.pageSize;
    const end = start + this.pageSize;

    this.sampleData.sort((a, b) =>
      SiteMasterService.compareSites(a, b, sortAttribute)
    );

    const selectedItems = this.sampleData.slice(start, end);

    this.itemCount = selectedItems.length;

    this.computeAvailablePages(page);
    this.currentPage = page;

    this._items.next(selectedItems);
    return this.items;
  }
  getAll(): SiteModel[] {
    return this.sampleData;
  }
  setData(data: SiteModel[]) {
    this.sampleData = data;
  }
  upsert(site: SiteModel): SiteModel {
    const index = this.sampleData.findIndex(
      (value) => value.siteId === site.siteId
    );
    if (index >= 0) {
      this.sampleData[index] = site;
    } else {
      site.siteId = (this.sampleData.length + 1).toString();
      this.sampleData.push(site);
    }
    this.queryAll(this._lastQuery);
    return site;
  }

  remove(sites: SiteModel[]) {
    this.sampleData = this.sampleData.filter((site) => sites.indexOf(site) < 0);
    this.queryAll(this._lastQuery);
  }

  private computeAvailablePages(page: number) {
    this.pageCount = Math.ceil(this.sampleData.length / this.pageSize);
    this.pages.length = 0;
    for (let i = 0; i < this.pageCount; i++) {
      this.pages.push({ index: i, active: i === page });
    }
  }
}
